import { render } from "./PriceLogExemptions.vue?vue&type=template&id=221e61ee"
import script from "./PriceLogExemptions.vue?vue&type=script&lang=js"
export * from "./PriceLogExemptions.vue?vue&type=script&lang=js"

import "./PriceLogExemptions.vue?vue&type=style&index=0&id=221e61ee&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__